import { CarEngine } from "src/app/public/car/models/car-engine.model";
import { CarFeature } from "src/app/public/car/models/car-feature.model";
import { CarJobTask } from "src/app/public/car/models/car-job-task.model";
import { CarJobTemplate } from "src/app/public/car/models/car-job-template.model";
import { CarMake } from "src/app/public/car/models/car-make.model";
import { CarManufacturer } from "src/app/public/car/models/car-manufacturer.model";
import { CarModel } from "src/app/public/car/models/car-model.model";
import { CarVersion } from "src/app/public/car/models/car-version.model";


export class CarRefStoreUtils{

    // manufacturers
    public static addManufacturer = ( manufacturers: CarManufacturer[], newItem: CarManufacturer ) => [...manufacturers, newItem];

    public static updateManufacturer = ( manufacturers: CarManufacturer[],  updated: CarManufacturer ) => 
        manufacturers.map ( manufacturer => {
            return manufacturer.id === updated.id 
                ? Object.assign({}, manufacturer, updated)
                : manufacturer ;
        });
        
    public static deleteManufacturer = ( manufacturers: CarManufacturer[], manufacturerId: number ) =>  manufacturers.filter(manufacturer => manufacturerId !== manufacturer.id);


    // makes
    public static addMake = ( makes: CarMake[], newItem: CarMake ) => [...makes, newItem];

    public static updateMake = ( makes: CarMake[],  updated: CarMake ) => 
        makes.map ( make => {
            return make.id === updated.id 
                ? Object.assign({}, make, updated)
                : make ;
        });
        
    public static deleteMake = ( makes: CarMake[], makeId: number ) =>  makes.filter(make => makeId !== make.id);

    // models
    public static addModel = ( models: CarModel[], newItem: CarModel ) => [...models, newItem];

    public static updateModel = ( models: CarModel[],  updated: CarModel ) => 
        models.map ( model => {
            return model.id === updated.id 
                ? Object.assign({}, model, updated)
                : model ;
        });
        
    public static deleteModel = ( models: CarModel[], modelId: number ) =>  models.filter(model => modelId !== model.id);

    // versions
    public static addVersion = ( versions: CarVersion[], newItem: CarVersion ) => [...versions, newItem];

    public static updateVersion = ( versions: CarVersion[],  updated: CarVersion ) => 
        versions.map ( version => {
            return version.id === updated.id 
                ? Object.assign({}, version, updated)
                : version ;
        });
        
    public static deleteVersion = ( versions: CarVersion[], versionId: number ) =>  versions.filter(version => versionId !== version.id);

    // engines
    public static addEngine = ( engines: CarEngine[], newItem: CarEngine ) => [...engines, newItem];

    public static updateEngine = ( engines: CarEngine[],  updated: CarEngine ) => 
        engines.map ( engine => {
            return engine.id === updated.id 
                ? Object.assign({}, engine, updated)
                : engine ;
        });
        
    public static deleteEngine = ( engines: CarEngine[], engineId: number ) =>  engines.filter(engine => engineId !== engine.id);


    // features
    public static addFeature = ( features: CarFeature[], newItem: CarFeature ) => [...features, newItem];

    public static updateFeature = ( features: CarFeature[],  updated: CarFeature ) => 
        features.map ( feature => {
            return feature.id === updated.id 
                ? Object.assign({}, feature, updated)
                : feature ;
        });
        
    public static deleteFeature = ( features: CarFeature[], featureId: number ) =>  features.filter(feature => featureId !== feature.id);


    // jobTemplates
    public static addJobTemplate = ( jobTemplates: CarJobTemplate[], newItem: CarJobTemplate ) => [...jobTemplates, newItem];

    public static updateJobTemplate = ( jobTemplates: CarJobTemplate[],  updated: CarJobTemplate ) => 
        jobTemplates.map ( jobTemplate => {
            return jobTemplate.id === updated.id 
                ? Object.assign({}, jobTemplate, updated)
                : jobTemplate ;
        });
        
    public static deleteJobTemplate = ( jobTemplates: CarJobTemplate[], jobTemplateId: number ) =>  jobTemplates.filter(jobTemplate => jobTemplateId !== jobTemplate.id);


    // jobTasks
    public static addJobTask = ( jobTasks: CarJobTask[], newItem: CarJobTask ) => [...jobTasks, newItem];

    public static updateJobTask = ( jobTasks: CarJobTask[],  updated: CarJobTask ) => 
        jobTasks.map ( jobTask => {
            return jobTask.id === updated.id 
                ? Object.assign({}, jobTask, updated)
                : jobTask ;
        });
        
    public static deleteJobTask = ( jobTasks: CarJobTask[], jobTaskId: number ) =>  jobTasks.filter(jobTask => jobTaskId !== jobTask.id);

}
